<script setup lang="ts">
import { useCompany } from '~/composables/useCompany';
const { company } = await useCompany();

useHead({
  titleTemplate: `%s | ${company.titleBar}`,
  meta: [
    {
      name: 'description',
      content: `${company.titleBar}の居住者向けサポートサイトです、よくあるご質問、メール電話でのお問い合わせはこちらから`,
    },
  ],
});
</script>

<template>
  <div :class="company.colorType">
    <Header :logo-url="company.logoUrl" />
    <main class="pt-4">
      <slot />
    </main>
    <Footer
      :company-title-bar="company.titleBar"
      :company-term-url="company.termUrl"
    />
  </div>
</template>
